export enum I18NLanguage {
  'english' = 'en',
}
